import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { MarkerDimension, PropertySummary } from '../../state/case/case.state'

@Injectable({
    providedIn: 'root',
})
export class MarkerCatalogService {
    private fullCatalog: MarkerDimension[] = []
    private byName = new Map<string, MarkerDimension>()
    private readonly catalog$ = new BehaviorSubject<MarkerDimension[]>([])

    setCatalog(markers: MarkerDimension[]): void {
        this.fullCatalog = [...markers].sort((a, b) => a.name.localeCompare(b.name))
        this.byName = new Map(this.fullCatalog.map(m => [m.name, m]))
        this.catalog$.next(this.fullCatalog)
    }

    clearCatalog(): void {
        this.fullCatalog = []
        this.byName.clear()
        this.catalog$.next([])
    }

    toPropertySummaries(markers: MarkerDimension[]): PropertySummary[] {
        return markers
            .map(({ name, lower_bound, upper_bound }) => ({ name, lower_bound, upper_bound }))
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    getFullMarker(name: string): MarkerDimension | undefined {
        return this.byName.get(name)
    }

    getAllMarkers(): MarkerDimension[] {
        return this.fullCatalog
    }

    getAllMarkers$(): Observable<MarkerDimension[]> {
        return this.catalog$.asObservable()
    }
}
